import React from 'react';
import { Pie } from 'react-chartjs-2';
import { Card, CardHeader, CardBody, Row, Col } from 'reactstrap';
import randomColor from 'randomcolor';
import * as styles from '../../../assets/style';

export function AgentPieChart({ title, data }) {
  if (!data || !data.labels || !data.values) return null;

  /*
   * Combine labels and values into an array of objects
   * Sort the array by value in ascending order
   * Create a new array of sorted labels and values
   * Generate random colors for each label
   */
  const combinedData = data.labels.map((label, i) => ({
    label,
    value: data.values[i]
  }));

  combinedData.sort((a, b) => a.value - b.value);

  const sortedLabels = combinedData.map((item) => item.label);
  const sortedValues = combinedData.map((item) => item.value);
  const dynamicColors = sortedLabels.map(() =>
    randomColor({ luminosity: 'bright', hue: 'random' })
  );

  const chartData = {
    labels: sortedLabels,
    datasets: [
      {
        data: sortedValues,
        backgroundColor: dynamicColors,
        borderColor: '#fff',
        borderWidth: 2,
        hoverOffset: 10
      }
    ]
  };

  /**
   * @description: Pie chart configuration
   * Chart.js options
   * Maintain aspect ratio
   * Responsive
   * Hide legend
   * Custom tooltip with percentage
   */
  const options = {
    maintainAspectRatio: false,
    responsive: true,
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        callbacks: {
          label: (context) => {
            const label = context.label || '';
            const value = context.raw || 0;
            const total = context.dataset.data.reduce((a, b) => a + b, 0);
            const percentage = ((value / total) * 100).toFixed(1);
            return ` ${label}: ${value} chamadas (${percentage}%)`;
          }
        }
      }
    }
  };

  return (
    <Card style={{ height: '550px' }}>
      {' '}
      {/* Altura fixa para o card */}
      <CardHeader className="title">
        <h5 className="h3 mb-0">{title}</h5>
      </CardHeader>
      <CardBody
        style={{
          height: 'calc(100% - 60px)',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <Row>
          <Col md="12">
            {/* Gráfico de Pizza com altura fixa */}
            <div style={{ height: '350px' }}>
              <Pie
                data={chartData}
                options={options}
                className="chart-canvas"
              />
            </div>

            <div
              style={{
                ...styles.legendContainer,
                maxHeight: '150px',
                overflowY: 'auto'
              }}
            >
              {sortedLabels.map((label, index) => (
                <div style={styles.legendItem} key={index}>
                  <div
                    style={{
                      ...styles.legendColor,
                      backgroundColor: dynamicColors[index]
                    }}
                  />
                  <span style={styles.legendLabel}>{label}</span>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
}
